import Business from "@material-ui/icons/Business";
// import Home from "@material-ui/icons/Home";
// import Person from "@material-ui/icons/Person";
import PropTypes from "prop-types";
import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import pricingPageStyle from "assets/jss/material-dashboard-pro-react/views/pricingPageStyle.jsx";

const styles = theme => {
  const themeStyles = { ...pricingPageStyle(theme) };

  return {
    ...themeStyles,
    description: {
      ...themeStyles.description,
      color: "black",
    },
    escolherLink: {
      color: "white",
      "&:focus": { color: "white" },
      "&:hover": { color: "white" },
      "&:visited": { color: "white" },
    },
    title: {
      ...themeStyles.title,
      color: "black",
    },
  };
};

const PlanosPage = ({ classes }) => (
  <div className={classes.container}>
    <GridContainer justify="center">
      <GridItem md={12} sm={12} xs={12}>
        <h2 className={classes.title}>
          Entre em contato e tenha acesso ao Energy Company imediatamente
        </h2>
        <h5 className={classes.description}>
          Nosso plano garante acesso ilimitado ao Dashboard e Relatórios, além de suporte personalizado.
        </h5>
        <h5 className={classes.description}>
          Entre em contato via <a href="mailto:contato@energycompany.com.br">contato@energycompany.com.br</a>
        </h5>
      </GridItem>
    </GridContainer>
    <GridContainer justify="center">
      {/*<GridItem md={3} sm={12} xs={12}>
        <Card pricing raised>
          <CardBody pricing>
            <h6 className={classes.cardCategory}>Individual</h6>
            <div className={classes.icon}>
              <Person className={classes.iconRose}>Ind.</Person>
            </div>
            <h3 className={`${classes.cardTitle} ${classes.marginTop30}`}>
              R$ 300/mês
            </h3>
            <p className={classes.cardDescription}>
              Ideal para uso individual ou empresa pequena.
            </p>
            <Button color="rose" round>
              <a className={classes.escolherLink} href="mailto:contato@energycompany.com.br?subject=Olá,%20gostaria%20de%20contratar%20o%20plano%20individual">Escolher este plano</a>
            </Button>
          </CardBody>
        </Card>
      </GridItem>

      <GridItem md={3} sm={12} xs={12}>
        <Card pricing raised>
          <CardBody pricing>
            <h6 className={classes.cardCategory}>Até 5 acessos simultâneos</h6>
            <div className={classes.icon}>
              <Home className={classes.iconRose} />
            </div>
            <h3 className={`${classes.cardTitle} ${classes.marginTop30}`}>
              R$ 300/mês
            </h3>
            <p className={classes.cardDescription}>
              Ideal para empresas entre 2 e 10 pessoas.
            </p>*
            <Button color="rose" round>
              <a className={classes.escolherLink} href="mailto:contato@energycompany.com.br?subject=Olá,%20gostaria%20de%20contratar%20o%20plano%20corporativo%20de%2010%20pessoas">Escolher este plano</a>
            </Button>
          </CardBody>
        </Card>
      </GridItem>*/}

      <GridItem md={3} sm={12} xs={12}>
        <Card pricing raised>
          <CardBody plain pricing>
            {/*<h6 className={classes.cardCategory}>Mais de 5 acessos simultâneos</h6>*/}
            <div className={classes.icon}>
              <Business className={classes.iconRose} />
            </div>
            <h3 className={`${classes.cardTitle} ${classes.marginTop30}`}>
            </h3>
            {/*<p className={classes.cardDescription}>
              Ideal para empresas com um grande número de funcionários.
            </p>*/}
            <Button color="rose" round>
              <a className={classes.escolherLink} href="mailto:contato@energycompany.com.br?subject=Olá,%20gostaria%20de%20negociar%20o%20plano%20para%20mais%20de%2010%20pessoas">
                Entrar em contato
              </a>
            </Button>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  </div>
);

PlanosPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PlanosPage);



// WEBPACK FOOTER //
// ./src/views/Pages/PlanosPage.jsx